import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function ModalLogout({ show, onHide }) {
  const { t } = useTranslation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    sessionStorage.removeItem("superAdmAuth");
    window.location.reload();
  };

  return (
    <Modal backdrop="static" centered size="md" show={show} onHide={onHide}>
      <Modal.Header closeVariant="white" closeButton>
        <Modal.Title>{t("exit_application")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t("confirm_exit_application")}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("button_close")}
        </Button>
        <Button variant="danger" onClick={handleLogout}>
          {t("button_exit")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ModalLogout.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default ModalLogout;
